export default __webpack_public_path__ + "static/media/pictogramSuperannuation64.187309cc.svg";